import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { FontManager } from "@/features/admin/components/font-manager";
import { PageContainer } from "@fleet/ui/page-container";

function AdminFontsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <FontManager />
    </PageContainer>
  );
}

/** URL-addressable admin font state: tab + search + category + open preview. */
interface AdminFontsSearch {
  tab?: "available" | "approved";
  /** Free-text search (the "Available" registry browser). */
  q?: string;
  /** Category filter (the "Available" registry browser). */
  category?: string;
  /** Id of the font whose preview dialog is open (registry id or family id). */
  font?: string;
}

export const adminFontsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/fonts",
  validateSearch: (search: Record<string, unknown>): AdminFontsSearch => ({
    tab:
      search.tab === "approved" ? "approved" : search.tab === "available" ? "available" : undefined,
    q: typeof search.q === "string" && search.q.trim() !== "" ? search.q : undefined,
    category:
      typeof search.category === "string" && search.category !== "all"
        ? search.category
        : undefined,
    font: typeof search.font === "string" && search.font.trim() !== "" ? search.font : undefined,
  }),
  component: AdminFontsPage,
});
